import React, { useEffect, useState } from "react";
import {Helmet} from "react-helmet-async";
import { useLocation } from "react-router-dom";

type MetaTagsProps = {
  title: string;
  description: string;
  ogTitle?: string;
  ogDescription?: string;
  type?: "website" | "article" | "product" | "profile" | "video.movie" | "music.song" | undefined;
  siteName?: string;
  imageUrl?: string;
  imageAlt?: string;
  noIndex?: boolean;
}

const MetaTags: React.FC<MetaTagsProps> = ({
  title,
  description,
  ogTitle,
  ogDescription,
  type,
  siteName,
  imageUrl,
  imageAlt,
  noIndex = false,
}) => {
  const [prodEnv, setProdEnv] = useState<boolean>(false);
  const location = useLocation();
  const defaultType = "website";
  const defaultSiteName = title;
  const defaultOgTitle = title;
  const defaultOgDescription = description;
  const defaultImageUrl = "https://res.cloudinary.com/antoniovillegas/image/upload/v1677289211/seoOzon_b0cxbs.png";
  const defaultImageAlt = "";

  useEffect(() => {
    setProdEnv(process.env.REACT_APP_ENV === "production");
  }, [noIndex]);

  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description}/>
      <meta property="og:type" content={type ?? defaultType}/>
      <meta property="og:site_name" content={siteName ?? defaultSiteName}/>
      <meta property="og:url" content={`https://ozon.mobi${location.pathname}`}/>
      <meta property="og:title" content={ogTitle ?? defaultOgTitle}/>
      <meta property="og:description" content={ogDescription ?? defaultOgDescription}/>
      <meta property="og:image" content={imageUrl ?? defaultImageUrl}/>
      <meta property="og:image:alt" content={imageAlt ?? defaultImageAlt}/>
      {(noIndex || !prodEnv) && <meta name="robots" content="noindex, follow" /> }
    </Helmet>
  );
};

export default MetaTags;
